module.exports = __webpack_public_path__ + "img/Icon_Manejo_de_Citas_Over.e282c20c.svg";